import axios from 'axios';
export class WaysteStripeService {
    config;
    auth;
    waysteStripeEndpoint = '';
    constructor(auth, config) {
        this.config = config;
        this.auth = auth;
        this.waysteStripeEndpoint = this.config.API.baseApiUrl + '/stripe/hauler';
    }
    get stripeEndpoints() {
        return {
            createStripeAccount: this.waysteStripeEndpoint + '/account',
            getStripeAccount: this.waysteStripeEndpoint + '/account',
            createStripeAccountLinkForOnboarding: this.waysteStripeEndpoint + '/account/link',
            createCharge: this.waysteStripeEndpoint + '/charge',
            createRefund: this.waysteStripeEndpoint + '/refund',
            customer: {
                create: this.waysteStripeEndpoint + '/customer',
                retrieve: (customerId) => this.waysteStripeEndpoint + `/customer/${customerId}`,
                addSource: (customerId) => this.waysteStripeEndpoint + `/customer/${customerId}/sources`,
                deleteSource: (customerId) => this.waysteStripeEndpoint + `/customer/${customerId}/sources`,
                getByEmail: (email) => this.waysteStripeEndpoint + `/customer?email=${email}`,
                update: (customerId) => this.waysteStripeEndpoint + `/customer/${customerId}`,
            },
        };
    }
    account = {
        create: () => this.createStripeAccount(),
        get: () => this.getStripeAccount(),
        onboardingLink: () => this.createStripeAccountLinkForOnboarding(),
    };
    charge = {
        create: ({ amount, customer, source }) => this.createCharge({
            amount,
            customer,
            source,
        }),
    };
    refund = {
        create: (data) => {
            return this.createRefund(data);
        },
    };
    customer = {
        create: (customer) => this.createCustomer(customer),
        update: (customerID, customer) => this.updateCustomer(customerID, customer),
        retrieve: (customerID) => this.retrieveCustomer(customerID),
        sources: {
            add: (customerID, sourceID) => this.addSourceToCustomer(customerID, sourceID),
            delete: (customerID, sourceID) => this.deleteSourceFromCustomer(customerID, sourceID),
        },
        getByEmail: (email) => this.getCustomerByEmail(email),
    };
    headers() {
        return {
            Authorization: `Bearer ${this.auth.currentToken}`,
        };
    }
    async createStripeAccount() {
        return (await axios.post(this.stripeEndpoints.createStripeAccount, {}, {
            headers: this.headers(),
        })).data;
    }
    /**
     * Creates a Stripe account link for onboarding
     * @param baseURL The base URL to redirect to after onboarding, (only works in development)
     * @returns the URL to redirect to
     *
     * */
    async createStripeAccountLinkForOnboarding(baseURL) {
        return (await axios.post(this.stripeEndpoints.createStripeAccountLinkForOnboarding, {
            baseURL,
        }, {
            headers: this.headers(),
        })).data;
    }
    async getStripeAccount() {
        return (await axios.get(this.stripeEndpoints.getStripeAccount, {
            headers: this.headers(),
        })).data;
    }
    async createCharge({ source, amount, customer }) {
        console.log('endpt', this.stripeEndpoints?.createCharge, this.stripeEndpoints);
        return (await axios.post(this.stripeEndpoints.createCharge, {
            source,
            amount,
            customer,
        }, {
            headers: this.headers(),
        })).data;
    }
    async createRefund(data) {
        return (await axios.post(this.stripeEndpoints.createRefund, data, {
            headers: this.headers(),
        })).data;
    }
    async createCustomer(customer) {
        return (await axios.post(this.stripeEndpoints.customer.create, customer, {
            headers: this.headers(),
        })).data;
    }
    async retrieveCustomer(customerId) {
        return (await axios.get(this.stripeEndpoints.customer.retrieve(customerId), {
            headers: this.headers(),
        })).data;
    }
    async addSourceToCustomer(customerId, sourceId) {
        return (await axios.post(this.stripeEndpoints.customer.addSource(customerId), {
            sourceId,
        }, {
            headers: this.headers(),
        })).data;
    }
    async deleteSourceFromCustomer(customerId, sourceId) {
        return (await axios.delete(this.stripeEndpoints.customer.deleteSource(customerId), {
            headers: this.headers(),
            data: {
                sourceId,
            },
        })).data;
    }
    async getCustomerByEmail(email) {
        return (await axios.get(this.stripeEndpoints.customer.getByEmail(email), {
            headers: this.headers(),
        })).data;
    }
    async updateCustomer(customerId, customer) {
        return (await axios.patch(this.stripeEndpoints.customer.update(customerId), customer, {
            headers: this.headers(),
        })).data;
    }
}
//# sourceMappingURL=WaysteStripe.service.js.map